<app-message-header></app-message-header>

<div class="fluid-container" class="container col-md-12 col-sm-12 col-xs-12 mainContainerStyle" style="background-color: #eeeeee;">
	<!--Loader-->
	<div class="page-loader" *ngIf="loadershow">
		<img src="assets/images/uib-loading-500x500.gif" alt = "image loader" style="width:100px;">
	</div>
	
	<!--Left Content-->
	<div class="col-md-7 col-sm-7 col-xs-7 leftContentStyle">

		<!--Application and Date Section-->
		<div class="row" class="leftContentRowStyle">
			<label class="col-md-2 col-xs-2 applicationlabelStyle" style="padding: 0px !important;text-align: center;margin: auto;"><strong>Application</strong></label>

			<!--Application List Drop Down-->
			<div class="col-md-5 col-xs-5 applicationListStyle" style="padding-left:0px !important;margin:auto;">
				
					<input value="{{selectedApplication.applicationName}}" disabled="true">
			       
			 
				
			</div>

			<!--Date Range Drop Down-->
			<div class="col-md-5 col-xs-5 dateDropDownStyle">
				<select name="dateRange" class="dateRange shadow" id="dateRange" [(ngModel)]="selectedDateRange" (change)="switchDateRange();">
					<option value="last30">{{ 'Dashboard.last30' | translate }}</option>
					<option value="choosedate">{{ 'Dashboard.dateRange' | translate }}</option>
				</select>
				<div *ngIf="chooseDate" class="dateSelectionDiv">
					<input class="form-control dateSelection" #drp="bsDaterangepicker" bsDaterangepicker [readonly]="true" [maxDate]="bsValue" [(ngModel)]="bsRangeValue" [bsConfig]="{ adaptivePosition: true,containerClass: 'theme-default',rangeInputFormat: 'DD-MM-YYYY' }" (bsValueChange)="selectDates($event)" >
				</div>
			</div>
		</div>

		<!--Period And Channels Section-->
		<div class="showRadioDiv shadow">
			<div class="col-md-6 col-xs-6 period-cls">				
				<p class="labelStyle"><strong>Period</strong></p>
				<div class="periodDivStyle">
					<div class="rangeSelection">
						<input type="radio" class="selectionRange" value="day" [(ngModel)]="selectedPeriod" name="selectionRange" (change)="selectChangePeriod('day')">
						{{ 'Dashboard.day' | translate }}
					</div>
					<div class="rangeSelection">
						<input type="radio" class="selectionRange" value="week" [(ngModel)]="selectedPeriod" name="selectionRange" (change)="selectChangePeriod('week')">
						{{ 'Dashboard.week' | translate }}
					</div>
					<div class="rangeSelection">
						<input type="radio" class="selectionRange" value="month" [(ngModel)]="selectedPeriod" name="selectionRange" (change)="selectChangePeriod('month')">
						{{ 'Dashboard.month' | translate }}
					</div>
				</div>				
			</div>

			<div class="col-md-6 col-xs-6 border-cls">
				<p class="labelStyle"><strong>Channels</strong></p>
				<div *ngIf="selectedApp" class="channelDivStyle grid-container">
					<label *ngFor="let connector of connectors; let i = index;" class="rangeSelection radioButtonDivStyle">
						<input type="radio" class="matBodyRadio" [checked]="i === 0" value="{{connector}}" name="conRadio" (change)="selectChangeChannel(connector)"> 
							<span style="vertical-align:text-bottom;">&nbsp;{{connector.name}}</span>
					</label>
				</div>
			</div>
		</div>

		<!--Graph Section-->
		<div class="graphLabel">
		<!--Message Sent Status Section-->
			<h5 class="col-md-12 col-xs-12 switchTabHeaderStyle">{{ 'Dashboard.graphLabel' | translate }}</h5>		
			<div class="col-md-12 col-xs-12 showChart" style="margin-bottom:3%;">
				<div *ngIf="noRecords" class="noRecordDiv"><strong>{{ 'Dashboard.noData' | translate }}</strong></div>				
				<img *ngIf="!noRecords && sentChartOptions.dataProvider.length == 0" src="assets/images/uib-loading-500x500.gif" alt="Sent Chart" width="25px;text-align:center;">
				<div *ngIf="!noRecords" id="chartdiv" class="chartStyle">
				</div>	
			</div>
		
		<!--Message Received Status Section-->
			<h5 class="col-md-12 col-xs-12 switchTabHeaderStyle" >{{ 'Dashboard.graphLabelReceived' | translate }}</h5>
			<div class="col-md-12 col-xs-12 showChart" style="margin-bottom:3%;">	
				<div *ngIf="noRecordsReceived" class="noRecordDiv"><strong>{{ 'Dashboard.noData' | translate }}</strong></div>				
				<img *ngIf="!noRecordsReceived && receivedChartOptions.dataProvider.length == 0" src="assets/images/uib-loading-500x500.gif" alt="Received Chart" width="25px;text-align:center;">
				<div *ngIf="!noRecordsReceived" id="chartdivReceived" class="chartStyle"></div>	
			</div>

		<!--Message Template Section-->
			<h5 class="col-md-12 col-xs-12 switchTabHeaderStyle" >{{ 'Dashboard.graphLabelTemplate' | translate }}</h5>
			<div class="col-md-12 col-xs-12 showChart">	
				<div *ngIf="noTemplateRecordsReceived" class="noRecordDiv"><strong>{{ 'Dashboard.noData' | translate }}</strong></div>				
				<img *ngIf="!noTemplateRecordsReceived && templateChartOptions.dataProvider.length == 0" src="assets/images/uib-loading-500x500.gif" alt="Template chart loader" width="25px;text-align:center;">
				<div *ngIf="!noTemplateRecordsReceived" id="chartdivTemplate" class="chartStyle"></div>	
			</div>
		</div>
	</div>

	<!--Right Content-->
	<div class="col-md-5 col-sm-5 col-xs-5 chartsData rightContentStyle">
		<!--Tab Switch Section-->
		<div class="tabSelectionDivStyle col-md-12 col-sm-12 col-xs-12">
			<button type="button" style="margin-right:1%;" class="col-md-6 col-sm-6 col-xs-6 btn btn-default tabButtonStyle" [ngClass]="{'activeTab' : showMessageSentStatus}" (click)="switchTab()">
				{{'Message Sent Status' | translate}}
			</button>
			<button type="button" class="col-md-6 col-sm-6 col-xs-6 btn btn-default tabButtonStyle" [ngClass]="{'activeTab' : showMessageReceivedStatus}" (click)="switchTab()">
				{{'Message Received Status' | translate}}
			</button>
		</div>

		<!--Message Sent Status Count Section-->
		<div *ngIf="showMessageSentStatus" class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px !important;">

		

			<div class="shadow tabStyle">
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle" style="font-weight:700;">
					{{ 'Dashboard.chartDataTotal' | translate }}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!totalSentMessageLoader" class="tabCountContentStyle">{{totalMessagesCount}}</label>
					<img *ngIf="totalSentMessageLoader" src="assets/images/uib-loading-500x500.gif" alt="Total messages count loader" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataToday' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{todaysDate | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!todaysCountLoader" class="tabCountContentStyle">{{todaysCount}}</label>
					<img *ngIf="todaysCountLoader" src="assets/images/uib-loading-500x500.gif" alt="Todays count loader" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataWeek' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{currentWeekStarts | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{currentWeekEnds | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!weeklyCountLoader" class="tabCountContentStyle">{{weeklyCount}}</label>
					<img *ngIf="weeklyCountLoader" src="assets/images/uib-loading-500x500.gif" alt="Weekly count loader" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataMonth' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{currentMonthStarts | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{currentMonthEnds | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!monthlyCountLoader" class="tabCountContentStyle">{{monthlyCount}}</label>
					<img *ngIf="monthlyCountLoader" src="assets/images/uib-loading-500x500.gif" alt="Monthly count loader" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataYear' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{currentYearStarts | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{currentYearEnds | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!yearlyCountLoader" class="tabCountContentStyle">{{yearlyCount}}</label>
					<img *ngIf="yearlyCountLoader" src="assets/images/uib-loading-500x500.gif" alt="Yearly count loader" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle" *ngIf="(selectedConnector && selectedConnector.name !== null && selectedConnector.name !== '' && selectedConnector.name !== undefined)">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataTotalMsgConnector' | translate }} {{this.selectedConnector.name}}</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!totalCountByConnectorsLoader" class="tabCountContentStyle">{{totalCountByConnectors}}</label>
					<img *ngIf="totalCountByConnectorsLoader" src="assets/images/uib-loading-500x500.gif" alt="Total Count By Connectors Loader" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle" *ngIf="selectedConnector && selectedConnector.hasHsm" style="margin-bottom: 0% !important;">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataHsm' | translate }}</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!hsmCountByConnectorsLoader" class="tabCountContentStyle">{{hsmCountByConnectors}}</label>
					<img *ngIf="hsmCountByConnectorsLoader" src="assets/images/uib-loading-500x500.gif" alt="hsm Count By Connectors Loader" width="25px">
				</div>
			</div>
		</div>

		<!--Message Received Status Count Section-->
		<div *ngIf="showMessageReceivedStatus" class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px !important;">
			<div class="shadow tabStyle">
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle" style="font-weight:700;">
					{{ 'Dashboard.chartDataTotalReceived' | translate }}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!totalReceivedMessageLoader" class="tabCountContentStyle">{{totalReceivedMessagesCount}}</label>
					<img *ngIf="totalReceivedMessageLoader" src="assets/images/uib-loading-500x500.gif" alt="Total Received Message Loader" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataToday' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{todaysDate | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!todaysReceivedCountLoader" class="tabCountContentStyle">{{todaysReceivedCount}}</label>
					<img *ngIf="todaysReceivedCountLoader" src="assets/images/uib-loading-500x500.gif" alt="Todays Received Count Loader" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataWeek' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{currentWeekStarts | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{currentWeekEnds | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!weeklyReceivedCountLoader" class="tabCountContentStyle">{{weeklyReceivedCount}}</label>
					<img *ngIf="weeklyReceivedCountLoader" src="assets/images/uib-loading-500x500.gif" alt="Weekly Received Count Loader" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataMonth' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{currentMonthStarts | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{currentMonthEnds | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!monthlyReceivedCountLoader" class="tabCountContentStyle">{{monthlyReceivedCount}}</label>
					<img *ngIf="monthlyReceivedCountLoader" src="assets/images/uib-loading-500x500.gif" alt="Monthly Received Count Loader" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataYear' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{currentYearStarts | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{currentYearEnds | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!yearlyReceivedCountLoader" class="tabCountContentStyle">{{yearlyReceivedCount}}</label>
					<img *ngIf="yearlyReceivedCountLoader" src="assets/images/uib-loading-500x500.gif" alt="Yearly Received Count Loader" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle" *ngIf="(selectedConnector && selectedConnector.name !== null && selectedConnector.name !== '' && selectedConnector.name !== undefined)">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataTotalReceivedMsg' | translate }} {{this.selectedConnector.name}}</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!totalReceivedCountByConnectorsLoader" class="tabCountContentStyle">{{totalReceivedCountByConnectors}}</label>
					<img *ngIf="totalReceivedCountByConnectorsLoader" src="assets/images/uib-loading-500x500.gif" alt="Total Received Count By Connectors Loader" width="25px">
				</div>
			</div> 
		</div>
	</div>
</div>
<app-footer></app-footer>